import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteEmailRecipientsFromAPI, fetchEmailRecipientsFromAPI, uploadEmailRecipientsFile as uploadEmailRecipientsFileAPI } from "../../../services/EmailRecipientsService";

export const fetchEmailRecipients = createAsyncThunk(
  "emailRecipients/fetchEmailRecipients",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchEmailRecipientsFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data email recipients");
    }
  }
);

export const deleteEmailRecipients = createAsyncThunk(
  "emailRecipients/deleteEmailRecipients",
  async (emailRecipientsId, { rejectWithValue }) => {
    try {
      const response = await deleteEmailRecipientsFromAPI(emailRecipientsId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data email recipients");
    }
  }
);

export const uploadEmailRecipientsFile = createAsyncThunk(
  "emailRecipients/uploadEmailRecipientsFile",
  async (file, { rejectWithValue }) => {
    try {
      const response = await uploadEmailRecipientsFileAPI(file);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || "Gagal upload file email recipients");
    }
  }
);

const emailRecipientsSlice = createSlice({
  name: "emailRecipients",
  initialState: {
    emailRecipients: [],
    loading: false,
    error: null,
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    totalCount: 0,
    active: 0,
    vendors: 0,
    emailRecipientsSearch: "",
    keywordSearch: "",
    columnFilters: {}
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = { ...state.columnFilters, ...action.payload };
    },
    resetEmailRecipientsState: (state) => {
      state.emailRecipients = [];
      state.loading = false;
      state.error = null;
      state.currentPage = 1;
      state.lastPage = 1;
      state.perPage = 10;
      state.firstItem = 1;
      state.totalCount = 0;
      state.active = 0;
      state.vendors = 0;
      state.emailRecipientsSearch = "";
      state.keywordSearch = "";
      state.columnFilters = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailRecipients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmailRecipients.fulfilled, (state, action) => {
        state.loading = false;
        state.emailRecipients = action.payload.data.emailRecipients || [];
        state.currentPage = action.payload.data.pagination?.current_page || 1;
        state.lastPage = action.payload.data.pagination?.last_page || 1;
        state.perPage = action.payload.data.pagination?.per_page || 10;
        state.firstItem = action.payload.data.pagination?.from || 1;
        state.totalCount = action.payload.data.pagination?.total || 0;
        state.active = action.payload.data.active ?? 0;
        state.vendors = action.payload.data.vendors ?? 0;
      })
      .addCase(fetchEmailRecipients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEmailRecipients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteEmailRecipients.fulfilled, (state, action) => {
        state.loading = false;
        state.emailRecipients = state.emailRecipients.filter(
          (emailRecipients) => emailRecipients.id !== action.meta.arg
        );
        state.totalCount = Math.max(0, state.totalCount - 1);
      })
      .addCase(deleteEmailRecipients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadEmailRecipientsFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadEmailRecipientsFile.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(uploadEmailRecipientsFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const {
  setPage,
  setPerPage,
  setKeywordSearch,
  setColumnFilters,
  resetEmailRecipientsState
} = emailRecipientsSlice.actions;

export default emailRecipientsSlice.reducer;
